import React, { type FC, type SVGAttributes } from 'react';

export const KpLogo: FC<SVGAttributes<SVGElement>> = (props) => (
    <svg
        width="1.2rem"
        height="1.2rem"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M11.9999 0L3.1577 4.73295L7.76567 0H5.2114L2.07427 4.35443V0H0V11.9999H2.07427V7.65253L5.2114 11.9999H7.76567L3.27735 7.41579L11.9999 11.9999V9.77138L4.04432 6.57974L11.9999 7.11425V4.88569L4.09472 5.39963L11.9999 2.22856V0Z"
            fill="currentColor"
        />
    </svg>
);
